const MAP = {
  disponivel: { bg: "bg-[#EAF0EA]", text: "text-[#083A6B]", dot: "bg-[#4A7C59]", label: "Disponível" },
  ocupado: { bg: "bg-[#FBE7DE]", text: "text-[#D4A652]", dot: "bg-[#D4A652]", label: "Ocupado" },
  manutencao: { bg: "bg-[#FBEDD1]", text: "text-[#8B6A1F]", dot: "bg-[#8B6A1F]", label: "Manutenção" },
  aguardando_limpeza: { bg: "bg-[#FEE7DE]", text: "text-[#B4472B]", dot: "bg-[#B4472B]", label: "Aguardando limpeza" },
  em_limpeza: { bg: "bg-[#DBE7F2]", text: "text-[#1E4C7A]", dot: "bg-[#3671B0]", label: "Em limpeza" },
  aguardando_liberacao: { bg: "bg-[#E9DFEF]", text: "text-[#5E3B7A]", dot: "bg-[#7B4FA1]", label: "Aguardando liberação" },
  "pre-reserva": { bg: "bg-[#FDF3E3]", text: "text-[#8B6A1F]", dot: "bg-[#8B6A1F]", label: "Pré-reserva" },
  hospedado: { bg: "bg-[#EAF0EA]", text: "text-[#083A6B]", dot: "bg-[#083A6B]", label: "Hospedado" },
  ativa: { bg: "bg-[#EAF0EA]", text: "text-[#083A6B]", dot: "bg-[#083A6B]", label: "Ativa" },
  finalizada: { bg: "bg-stone-200", text: "text-stone-700", dot: "bg-stone-500", label: "Finalizada" },
  cancelada: { bg: "bg-[#FBE7DE]", text: "text-[#D4A652]", dot: "bg-[#D4A652]", label: "Cancelada" },
};

export function StatusPill({ status, testid, size = "md" }) {
  const s = MAP[status] || { bg: "bg-stone-100", text: "text-stone-600", dot: "bg-stone-400", label: status };
  const sz = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full font-medium ${sz} ${s.bg} ${s.text}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
}

export const STATUS_MAP = MAP;
